// extracted by mini-css-extract-plugin
module.exports = {"page":"NoAccessAccountPage_page__YE2Ps","title":"NoAccessAccountPage_title__31F9v","info":"NoAccessAccountPage_info__1GhZm","accountList":"NoAccessAccountPage_accountList__1KfYj"};